import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { faqs } from '@/mocks/home';

interface Props {
  items?: { q: string; a: string }[];
  eyebrow?: string;
  title?: string;
  className?: string;
}

export default function FAQAccordion({ items = faqs, eyebrow = 'GOOD TO KNOW', title = 'Your Questions, Answered.', className = '' }: Props) {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section className={`py-16 md:py-20 lg:py-[112px] px-4 md:px-6 lg:px-20 ${className}`}>
      <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-6">
        <div className="lg:col-span-4">
          <SectionHeading eyebrow={eyebrow} title={title} />
        </div>
        <div className="lg:col-span-7 lg:col-start-6 border-t border-background-300">
          {items.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="border-b border-background-300">
                <h3>
                  <button type="button" id={`faq-btn-${i}`} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-center justify-between gap-6 py-6 text-left cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary-500 rounded-md">
                    <span className="text-base md:text-lg font-medium">{f.q}</span>
                    <span className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-[color,background-color,transform] duration-500 ${isOpen ? 'rotate-180' : 'rotate-0'} ${isOpen ? 'bg-background-200 text-secondary-500' : 'border border-background-300'}`}><i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} /></span>
                  </button>
                </h3>
                <div
                  id={`faq-panel-${i}`}
                  role="region"
                  aria-labelledby={`faq-btn-${i}`}
                  aria-hidden={!isOpen}
                  className={`grid transition-[grid-template-rows,opacity] duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
                >
                  <div className="overflow-hidden">
                    <p className="pb-6 pr-12 text-[15px] md:text-base leading-[1.6] text-foreground-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}